import { SearchRequestResponseHeaders } from '../helpers/smart_search_request_response_headers_helper';
import { usermode } from '../types/smart_search_user_modes';
export const smartCatalogConfiguration = (userMode: usermode) => {
  const { postRequestHeaders = {}, getRequestHeaders = {} } = new SearchRequestResponseHeaders(userMode);
  return {
    system: {
      name: 'sgd_smart_catalogue_search',
      prefab: '@hip/search',
      engine: '19.1.0',
      version: '1',
      enviroment: 'dev'
    },
    import: {
      plugins: [
        '@preloaded/sgd_metadata_columns',
        '@preloaded/sgd_metadata_fields',
        '@preloaded/sgd_multi_form',
        '@preloaded/plan_to_term_action'
      ]
    },
    configuration: {},
    life_cycle: {
      initialize: {
        $finish: []
      }
    },
    action: {
      search_action: {
        kind: 'sgd_multi_form'
      },
      on_server_error: {
        $do: ['=>> _search_results_loading_indicator:hidden <=< true', '=>> _search_results_empty:hidden <=< false']
      },

      paginate_results: {
        kind: 'sgd_multi_form'
      },
      sort_results: {
        kind: 'sgd_multi_form'
      },
      course_details: {
        name: 'course_details',
        $widget: {
          $behavior: 'link',
          title: 'Details',
          kind: 'ghost',
          $region: 'details_region',
          input_mode: 'singular'
        }
      },
      add_to_term: {
        name: 'add_to_term',
        $widget: {
          $behavior: 'link',
          title: 'Add to Term',
          kind: 'ghost',
          $region: 'add_to_term_region',
          input_mode: 'singular'
        }
      }
    },
    bucket: {
      context: {
        $reactive_values: {
          search_title: 'Search',
          search_button_label: 'Search',
          reset_button_label: 'Clear',
          results_grid_theme: 'blue',
          no_result_title: 'Nothing Found!',
          no_result_tip: 'Check your keywords or try adjusting the filters',
          results_placeholder_title: 'Enter a keyword to search a course title or description.',
          results_placeholder_tip: 'Try searching for e.g. Psych, Psychology, or Intro to Psych',
          sorting: {
            default_sort_key: 'id'
          },
          pagination: {
            range_size: 3,
            page_size: 50,
            max: 250
          }
        }
      },
      form_fields: {
        type: {
          $ref: '#/type/form_fields'
        }
      },
      results: {
        type: {
          $ref: '#/type/results'
        }
      }
    },
    io: {
      search_query: {
        method: 'POST',
        uri: '/api/v1/academicplan/course/search/',
        allowFail: true,
        manual: true,
        $error: '((on_server_error))',
        headers: postRequestHeaders
      },
      search_request: {
        uri: '/api/v1/academicplan/course_search_fields/',
        manual: true,
        kind: 'sgd_metadata_fields',
        headers: getRequestHeaders
      },
      search_response: {
        uri: '/api/v1/academicplan/course_search_columns/',
        manual: true,
        kind: 'sgd_metadata_columns',
        headers: getRequestHeaders
      }
    }
  };
};

export default smartCatalogConfiguration;



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/smart_catalog/configuration/search_prefab_configuration.ts